module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace4-07c53f1e26311c97e51537ed34e1f4f1.jpg";